import audioMixin from '@/mixins/audio'
import { mapState } from 'vuex'

export default (key) => {
  return {
    mixins: [audioMixin()],
    computed: {
      thumb () {
        return this.thumbs.find(t => t.key == key) || {}
      },
      title () {
        return this.thumb.title
      },
      ...mapState(['thumbs']),
    },
    methods: {
      async init () {
        await this.initAudio()
        this.audioPlay()
      },
      async initAudio () {
        await Promise.all(this.files.map(async (file) => {
          return await this.audioLoad({ src: [file] })
        }))
        this.$on('audio:stop', this.handleAudioEnd)
        this.$on('audio:end', this.handleAudioEnd)
      },
      handleAudioEnd (key) {
        if (key + 1 < this.audioMap.length) {
          this.audioPlay(key + 1)
        } else {
          this.end()
        }
      },
      handleSkip () {
        this.end()
      },
      end () {
        this.$emit('end')
      },
    },
  }
}
